import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'
import ReactTable from 'react-table'
import "react-table/react-table.css";


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';

class ViewProducts extends Component{

	constructor(){
    super();
    this.count=this.count.bind(this)
    this.redirect = this.redirect.bind(this)
    this.removeProduct = this.removeProduct.bind(this);
    this.state = {
            userId : "",
            user : {},
            productsList : {}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });
        
        var list = ref.child('Products').orderByChild('status').equalTo('Active');
            list.on("value", function(data){
            
                this.setState({
                productsList : data.val()
                })
            
            }.bind(this))       
    } 

    redirect(id){
        window.location.assign("/products/"+id+"/edit")
    }
    count(){
       var x = [];
       var count;
        this.state.productsList &&
        Object.keys(this.state.productsList).map(key => {
            let list = this.state.productsList[key]
                list.id = key
            x.push(list)
            }) 
        count = x.length
        return count
    }
    removeProduct(prodId){
        let productsList = this.state.productsList;
        let product = {}
        if(window.confirm("Do you really want to remove this product")===true){
            Object.keys(productsList).map(key =>{
                product = productsList[prodId] 
                if(product === productsList[key]){
                    let statusUpdate ={
                        status : "Inactive"
                    }
                    ref.child("Products").child(prodId).update(statusUpdate).then(()=>{
                        alert("Product successfully deleted ")
                    })// end of update in the firebase
                } // end of condition  
            } ) //end of loop
        }// end of window confirm
    }


    componentWillUnmount(){
        this.listener()
    } 

    render() {
        var x = [];
        this.state.productsList &&
        Object.keys(this.state.productsList).map(key => {
            let list = this.state.productsList[key]
                list.id = key
                list.name = list.name.toUpperCase();
                list.unit = list.unit.toUpperCase();
                list.category = list.category.toUpperCase();
                list.status = list.status.toUpperCase();
            x.push(list)
            }) 
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="View Products" />
                            <div className="row text-center">
                                <div className="col-sm-6 col-lg-3">
                                    <a href="products/new" className="widget widget-hover-effect2">
                                        <div className="widget-extra themed-background-success">
                                            <h4 className="widget-content-light"><strong>Add New</strong> Product</h4>
                                        </div>
                                        <div className="widget-extra-full"><span className="h2 text-success animation-expandOpen"><i className="fa fa-plus"></i></span></div>
                                    </a>
                                </div>
                                <div className="col-sm-6 col-lg-3">
                                    <a href="javascript:void(0)" className="widget widget-hover-effect2">
                                        <div className="widget-extra themed-background-dark">
                                            <h4 className="widget-content-light"><strong>All</strong> Products</h4>
                                        </div>
                                        <div className="widget-extra-full"><span className="h2 themed-color-dark animation-expandOpen">{this.count()}</span></div>
                                    </a>
                                </div>
                                <div className="col-sm-6 col-lg-3">
                                </div>
                                <div className="col-sm-6 col-lg-3">
                                </div>
                            </div>
                            <div className="block">
                              <div className="block full">
                                <div className="block-title">
                                  <h2><strong>All</strong> Products</h2>
                                </div>
                                    <ReactTable
                                        data={x}
                                        columns={[
                                            {
                                                Header: "Product Name",
                                                accessor : "name",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                            },
                                            {
                                                Header: "Price",
                                                columns: [{
                                                            Header: '0.4MM',
                                                            accessor: 'price_4MM'
                                                          }, {
                                                            Header: '0.5MM',                                                            
                                                            accessor: 'price_5MM'
                                                          },{
                                                            Header: '0.6MM',                                                            
                                                            accessor: 'price_6MM'
                                                          },{
                                                            Header: '0.8MM',                                                            
                                                            accessor: 'price_8MM'
                                                          },]

                                            },
                                            {
                                                Header: "Unit",
                                                accessor : "unit",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                            },
                                            {
                                                Header: "Category",
                                                accessor : "category",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                            },
                                            {
                                                Header: "Status",
                                                accessor : "status",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },

                                            },
                                            {
                                                Header: 'Action',
                                                accessor : "id",
                                                Cell : row => (
                                                    <span><button onClick={()=>this.redirect(row.value)}><i className="fa fa-pencil"></i></button>
                                                    <button onClick={()=>this.removeProduct(row.value)}><i className="fa fa-times"></i></button></span>
                                                )
                                                                                   
                                            }
                                        ]}
                                        
                                        filterable ={true}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                    />
                                
                              </div>    
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default  ViewProducts;



// WEBPACK FOOTER //
// ./src/components/ViewProducts.js